import { route_get_device, route_device_types } from "../constants/BackendRoutes.js";
import axiosInstance from '../utils/axiosInstance.js';

export async function fetchDevice(deviceId) {
  const url = `${route_get_device}/${deviceId}`;

  try {
    const response = await axiosInstance.get(url);  
    return response.data;

  } catch(err) {
    console.error('[fetchDevice] Error:', err);
    throw new Error('Failed to fetch device', err);
  }
}

export async function fetchDeviceTypes () {
  const url = `${route_device_types}`;
  try {
    const response = await axiosInstance.get(url);  
    console.log( response.data );
    return response.data;

  } catch(err) {
    console.error('[fetchDeviceTypes] Error:', err);
    throw new Error('Failed to fetch Device List', err);
  }
}